var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tabs',{staticClass:"menu-tag-list",attrs:{"activeKey":_vm.currentOp},on:{"change":_vm.handleTagChange}},_vm._l((_vm.tagList),function(item){return _c('a-tab-pane',{key:item.op,attrs:{"tab":item.tag,"disabled":item.disabled}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }